export default "__VITE_ASSET__uxlLYgJ$__"